import { memo, ReactNode } from 'react'
import cn from 'classnames'

import s from './PlaceholderCell.module.less'

interface IProps {
  children?: ReactNode
  className?: string
  height?: number
  isLoading?: boolean
  seed?: number
}

export const PlaceholderCell = memo(function PlaceholderCell({ className, seed, children, height = 16 }: IProps) {
  return (
    <div
      style={{ height }}
      className={cn(s.PlaceholderCell, className, {
        [s.PlaceholderCell_1]: seed && seed % 1 === 0,
        [s.PlaceholderCell_2]: seed && seed % 2 === 0,
        [s.PlaceholderCell_3]: seed && seed % 3 === 0,
        [s.PlaceholderCell_5]: seed && seed % 5 === 0,
        [s.PlaceholderCell_420]: seed && seed % 420 === 0,
        [s.PlaceholderCell_60]: seed && seed % 60 === 0
      })}
    >
      {children}
    </div>
  )
})
